export const T = {
  en_GB: {
    historicalReturn: "Historical Return",
    statistics: "Statistics",
    monthlyPoints: "Monthly Points",
    expectedReturn: "Expected Return",
    expectedVolatility: "Expected Volatility",
    instrumentCurrency: "Instrument Currency",
    calculatedCurrency: "Calculated Currency",
    lastPrice: "Last Price",
    orderType: "Order Type",
    orderAmount: "Amount",
    orderUnits: "Units",
    dataPoints: "Data Points",
    xray: "X-Ray",
    assetAllocation: "Asset Allocation",
    country: "Country",
    region: "Region",
    stockSector: "Stock Sector",
    bondSector: "Bond Sector",
    equityStyle: "Equity Style",
    topHoldings: "Top Holdings",
    sustainability: "Sustainability",
    sfdr: "SFDR",
    sfdrArticle: (n: string) => `Article ${n}`,
    sfdrNone: "Not reported",
    exclusionsHeading: "Exclusions (stated policy)",
    exclusionsHint:
      "Sectors the fund states it excludes (European ESG Template — EET). Sectors it does not report are omitted.",
    involvementHeading: "Product involvement",
    involvementHint: "Sectors the fund has exposure to (Morningstar Product Involvement).",
    notReported: "Not reported",
    involved: "Involved",
    notInvolved: "Not involved",
    excluded: "Excluded",
    notExcluded: "Not excluded",
    noSustainability: "No vendor sustainability data",
    loading: "Loading…",
    na: "N/A",
    noStats: "No historical data available for this instrument.",
    measuredTo: (date: string) =>
      `No new prices since ${date}. The historical return, the expected return and volatility, and the statistics end there instead of carrying that price to today.`,
    noXray: "X-Ray analysis is not available for this product.",
    noDataForView: "No data available for this view.",
    snapshotTaken: (time: string) => `Snapshot taken ${time}`,
  },
  nb_NO: {
    historicalReturn: "Historisk avkastning",
    statistics: "Statistikk",
    monthlyPoints: "Månedlige punkter",
    expectedReturn: "Forventet avkastning",
    expectedVolatility: "Forventet volatilitet",
    instrumentCurrency: "Instrumentvaluta",
    calculatedCurrency: "Beregnet valuta",
    lastPrice: "Siste pris",
    orderType: "Ordretype",
    orderAmount: "Beløp",
    orderUnits: "Andeler",
    dataPoints: "Datapunkter",
    xray: "Røntgen",
    assetAllocation: "Aktivaklasse",
    country: "Land",
    region: "Region",
    stockSector: "Aksjesektor",
    bondSector: "Obligasjonssektor",
    equityStyle: "Aksjestil",
    topHoldings: "Største beholdninger",
    sustainability: "Bærekraft",
    sfdr: "SFDR",
    sfdrArticle: (n: string) => `Artikkel ${n}`,
    sfdrNone: "Ikke rapportert",
    exclusionsHeading: "Ekskluderinger (uttalt policy)",
    exclusionsHint:
      "Sektorer fondet oppgir at det ekskluderer (European ESG Template — EET). Sektorer det ikke rapporterer, utelates.",
    involvementHeading: "Produktinvolvering",
    involvementHint: "Sektorer fondet har eksponering mot (Morningstar Product Involvement).",
    notReported: "Ikke rapportert",
    involved: "Involvert",
    notInvolved: "Ikke involvert",
    excluded: "Ekskludert",
    notExcluded: "Ikke ekskludert",
    noSustainability: "Ingen bærekraftsdata fra leverandør",
    loading: "Laster…",
    na: "N/A",
    noStats: "Ingen historiske data tilgjengelig for dette instrumentet.",
    measuredTo: (date: string) =>
      `Ingen nye kurser siden ${date}. Historisk avkastning, forventet avkastning og volatilitet samt statistikken slutter der, i stedet for at kursen føres videre til i dag.`,
    noXray: "Røntgenanalyse er ikke tilgjengelig for dette produktet.",
    noDataForView: "Ingen data tilgjengelig for denne visningen.",
    snapshotTaken: (time: string) => `Øyeblikksbilde tatt ${time}`,
  },
} as const;
